import { callAuditService } from '../api/api'

const win = window
const errorPage = win['errorPageURL'];
const timeoutPage = win['timeoutPageURL']

export const handleApiError = (error) => {
    const genericErrorPage = `${errorPage}`
    const timeoutErrorPage = `${timeoutPage}`

    callAuditService(error).finally(() => {
        const redirectURL = error?.response?.status === 504 ? timeoutErrorPage : genericErrorPage;
        window.location.href = redirectURL;
    });
}